import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface KPICardProps {
  icon: ReactNode;
  title: string;
  value: string;
  trend: {
    value: string;
    direction: "up" | "down";
  };
  className?: string;
  variant?: 'default' | 'compact';
}

export const KPICard = ({ icon, title, value, trend, className, variant = 'default' }: KPICardProps) => {
  if (variant === 'compact') {
    return (
      <div className={cn("kpi-card-compact", className)}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="kpi-icon-compact bg-brand-secondary text-brand-primary">
              {icon}
            </div>
            <div>
              <p className="text-xs text-muted-foreground">{title}</p>
              <p className="text-lg font-bold">{value}</p>
            </div>
          </div>
          <div className="kpi-trend-compact">
            <i className={cn(
              "fa-solid text-xs",
              trend.direction === "up" ? "fa-arrow-trend-up" : "fa-arrow-trend-down"
            )} />
            <span className="text-xs">{trend.value}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("kpi-card", className)}>
      <div className="flex justify-between items-center mb-2">
        <div className="kpi-icon bg-brand-secondary text-brand-primary">
          {icon}
        </div>
        <div className="kpi-trend-positive">
          <i className={cn(
            "fa-solid text-xs",
            trend.direction === "up" ? "fa-arrow-trend-up" : "fa-arrow-trend-down"
          )} />
          <span>{trend.value}</span>
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{title}</p>
      <p className="text-3xl font-space-grotesk font-bold mt-1 text-foreground">{value}</p>
    </div>
  );
};